// src/components/WhatsAppNotificationBanner.js
import React, { useState } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import axios from 'axios';

const WhatsAppNotificationBanner = ({ userId, initialNumber }) => {
  const [phoneNumber, setPhoneNumber] = useState(initialNumber || '+254');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage('');

    try {
      const response = await axios.post('/api/update-whatsapp-number/', { // Updated URL
        user_id: userId,
        whatsapp_notification_number: phoneNumber,
      });
      setMessage('Updated successfully! You’ll receive notifications.');
    } catch (error) {
      setMessage('Error updating. Please try again.');
      console.error('Update failed:', error.response?.data);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-gray-800 bg-opacity-90 rounded-lg p-3 shadow-lg border border-gray-700 max-w-xs">
      <h3 className="text-sm font-semibold text-white flex items-center mb-2">
        <FaWhatsapp className="text-green-500 mr-2" /> Never miss an update or job. Notifications straight to WhatsApp!
      </h3>
      <p className="text-xs text-gray-300 mb-2">
        Add/update your WhatsApp for notifications. 😊
      </p>
      <form onSubmit={handleSubmit} className="flex items-center gap-2">
        <input
          type="tel"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          placeholder="+254712345678"
          className="px-2 py-1 text-xs border border-gray-600 rounded bg-gray-700 text-white focus:outline-none focus:ring-1 focus:ring-green-500 w-32"
          required
          pattern="\+254[0-9]{9}"
          title="Enter a valid Kenyan number (e.g., +254712345678)"
        />
        <button
          type="submit"
          disabled={isLoading}
          className="px-2 py-1 text-xs bg-green-500 text-white rounded hover:bg-green-600 focus:outline-none focus:ring-1 focus:ring-green-500 disabled:opacity-50"
        >
          {isLoading ? '...' : 'Save'}
        </button>
      </form>
      {message && <p className="text-xs mt-1 text-green-400">{message}</p>}
    </div>
  );
};

export default WhatsAppNotificationBanner;
